import React from 'react';
import { connect, WithStore, MapStateToProps, MapDispatchToProps } from '../../redux/services/Imports';
import './CardBlog.scss';
import './CardBlog-media.scss';
import { Props } from './interfaces';
import { GetTypeNews } from '../../services/GlobalFunctions';

import { EnumUrlsPages } from '../../services/Enum';
import {Link} from "../Link/Link";

const CardBlog = ({ alias, uri, image, imageStretchy, title, date, type, link, linkOut, stretchy, widthWindow }: Props) => {
  const imgSrc = stretchy && imageStretchy ? imageStretchy : image;
  const contentCard = (
    <>
      {imgSrc ? (
        <img
          src={`${imgSrc}`}
          className="card-blog__image"
          alt="card-blog"
          style={widthWindow > 720 ? {} : { opacity: '0.4' }}
        />
      ) : (
        <div className="card-blog__image"></div>
      )}
      <div className="card-blog__shadow"></div>
      <div className="card-blog__content">
        <p className="card-blog__type">{GetTypeNews(type)}</p>
        <div>
          <h3 className="card-blog__title">{title}</h3>
          <p className="card-blog__date">{date}</p>
        </div>
      </div>
    </>
  );

  const className = `card-blog${stretchy ? ' card-blog_stretchy' : ''}`;
  return linkOut ? (
    <a href={link} className={className}>
      {contentCard}
    </a>
  ) : (
    <Link
      to={uri ? uri : `${EnumUrlsPages.live}${alias}/`}
      className={className}
    >
      {contentCard}
    </Link>
  );
};

export default WithStore()(connect(MapStateToProps, MapDispatchToProps)(CardBlog));
